
import {
    Dialog,
    DialogContent,
    DialogActions,
    Typography,
    Button,
} from '@mui/material';

import {
    Trans
} from 'react-i18next'

function RemoveAdminDialog({ open, onClose, onSubmit }) {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogContent>
                <Typography variant='h5'>
                    <Trans i18nKey='achtung' ns='userSettingsPage' >Achtung</Trans>
                </Typography>
                <Typography variant='subtitle1'>
                    <Trans i18nKey='entferneAdmin' ns='userSettingsPage' >Du entfernst deine eigenen Administrator Rechte.</Trans>
                </Typography>
                <Typography variant='subtitle1'>
                    <Trans i18nKey='sicher' ns='userSettingsPage' >Bist du dir sicher?</Trans>
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    <Trans i18nKey='abbrechen' ns='userSettingsPage' >Abbrechen</Trans>
                </Button>
                <Button onClick={onSubmit} variant='contained'>
                    <Trans i18nKey='fortfahren' ns='userSettingsPage' >
                        Fortfahren
                    </Trans>
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default RemoveAdminDialog
